import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ApiService } from 'src/app/services/api.service';
import { NotifyService } from 'src/app/services/notify.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';
import { saveAs } from 'file-saver';
import { Observable, Observer } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { GalleryAddComponent } from '../gallery-add/gallery-add.component';

@Component({
  selector: 'app-gallery-list',
  templateUrl: './gallery-list.component.html',
  styleUrls: ['./gallery-list.component.css'],
})
export class GalleryListComponent implements OnInit {
  displayedColumns: string[] = ['index', 'galleryTags', 'action'];
  dataSource: MatTableDataSource<any>;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  private listApi = environment.url + environment.galleryList;
  private deleteApi = environment.url + environment.galleryDelete;
  /**
   * Constructs a new instance of the GalleryListComponent
   * @param makeapi API service provider
   * @param getdata Value service provider
   * @param notify Notification service provider
   * @param dialog Material dialog service provider
   */
  constructor(
    private makeapi: ApiService,
    private getdata: ValueService,
    private notify: NotifyService,
    public dialog: MatDialog
  ) {
    /**
     * Initialize the MatTableDataSource with empty data
     */
    this.dataSource = new MatTableDataSource();
  }

  roleValue;
  /**
   * OnInit lifecycle hook
   * Called when the component is initialized
   */
  ngOnInit(): void {
    // Show the loading indicator
    this.getdata.isVisibleSource.next(true);
    // Get the user's role from session storage
    this.roleValue = sessionStorage.getItem('role');
    // Get the list of galleries
    this.galleryList();
  }
  /**
   * Downloads the specified file from a given URL.
   */
  downloadMyFile() {
    // URL of the file to download
    const fileUrl =
      'https://s3.ap-south-1.amazonaws.com/startuptn-documents/profile/5268-test.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Date=20230427T093802Z&X-Amz-SignedHeaders=host&X-Amz-Expires=3600&X-Amz-Credential=AKIARQ5A67NEG6WLYOAF%2F20230427%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Signature=4f02afe0dd94319c168ccf528bbed17b58f33ae014c1da4215a62a4ad35c73e4';

    // Use FileSaver to save the file
    saveAs(fileUrl);
  }
  list = {};
  disList: any = [];
  pageTotalCount: number;
  pageSize: number = 25;
  pageNumber: number = 1;
  /**
   * Fetches the list of galleries from the API
   * @param event Pagination event from the Material table
   */
  galleryList(event?: any) {
    // Set the pagination parameters
    this.list = {
      listSize: this.pageSize,
      pageNumber: event ? event.pageIndex + 1 : this.pageNumber,
    };
    // Call the API to get the list of galleries
    this.ListApi();
  }
  noData = true;
  /**
   * Fetches the list of galleries from the API
   * @param list Request parameters sent to the API
   * @returns An observable containing the response from the API
   */
  ListApi() {
    return this.makeapi
      .method(this.listApi, this.list, 'post')
      .subscribe((data) => {
        // If there is no data, set the noData flag to true
        if (data.count === 0) {
          this.noData = true;
        } else {
          // Set the noData flag to false and update the component data
          this.noData = false;
          this.pageTotalCount = data.count;
          this.disList = data.responsemodelList;
          // Update the MatTableDataSource with the new data
          this.dataSource = new MatTableDataSource(data.responsemodelList);
        }
      });
  }
  /**
   * AfterViewInit lifecycle hook
   * Called when the component is initialized after the view
   * Sets the paginator for the MatTableDataSource
   */
  ngAfterViewInit() {
    // Set the paginator for the MatTableDataSource
    this.dataSource.paginator = this.paginator;
  }
  /**
   * Applies a filter to the MatTableDataSource
   * Called when the user enters text into the filter input
   * @param event The event containing the filter value
   */
  applyFilter(event: Event) {
    // Get the filter value from the event target, trim and convert to lowercase
    const filterValue = (event.target as HTMLInputElement).value
      .trim()
      .toLowerCase();
    // Apply the filter to the MatTableDataSource
    this.dataSource.filter = filterValue;
  }
  /**
   * Called when the user paginates the table
   * @param event The pagination event
   */
  getServerData(event) {
    // Update the page number and page size
    this.pageNumber = event.pageIndex + 1;
    this.pageSize = event.pageSize;
    // Create the request parameters
    this.list = {
      listSize: this.pageSize,
      pageNumber: this.pageNumber,
    };
    // Call the API to get the updated data
    this.ListApi();
  }
  /**
   * Opens a dialog to add a new gallery
   * @param value - The title of the gallery to be added
   */
  eventAddBtn(value) {
    // Open the GalleryAddComponent dialog with the provided title
    const dialogRef = this.dialog.open(GalleryAddComponent, {
      width: '650px',
      data: { title: value },
    });

    // After the dialog is closed, refresh the gallery list
    dialogRef.afterClosed().subscribe((result) => {
      this.galleryList();
    });
  }
  /**
   * Opens a dialog to edit a gallery
   * @param value - The title of the gallery to be edited
   * @param id - The id of the gallery to be edited
   */
  editGallery(value, id) {
    // Open the GalleryAddComponent dialog with the provided title and id
    const dialogRef = this.dialog.open(GalleryAddComponent, {
      width: '650px',
      data: { title: value, _id: id },
    });

    // After the dialog is closed, refresh the gallery list
    dialogRef.afterClosed().subscribe((result) => {
      this.galleryList();
    });
  }
  /**
   * Deletes a gallery with the given id
   * @param id The id of the gallery to be deleted
   */
  deleteGallery(id) {
    // Create an array with the id to be passed to the API
    let getdata = [id];
    /**
     * Call the API to delete the gallery
     * @param getdata The id of the gallery to be deleted
     */
    this.makeapi.method(this.deleteApi, getdata, 'post').subscribe((data) => {
      // If the response status is success, notify the user and refresh the gallery list
      if (data.responseStatus == 'Success') {
        this.notify.notifysuccess(data.responseMessage);
        this.galleryList();
      } else {
        // If the response status is not success, notify the user with the error message
        this.notify.notifyError(data.responseMessage);
      }
    });
  }

  base64Image: any;
  /**
   * Downloads an image from a specified URL and saves it as a file
   * Converts the image to a base64 encoded string before saving
   */
  downloadImage() {
    // URL of the image to be downloaded
    let imageUrl =
      'http://southparkstudios.mtvnimages.com/shared/characters/celebrities/mr-hankey.png?height=165';

    // Fetch the base64 encoded string of the image
    this.getBase64ImageFromURL(imageUrl).subscribe((base64data) => {
      // Prefix the base64 string with the data URL scheme
      this.base64Image = 'data:image/jpg;base64,' + base64data;

      // Create a link element for downloading the image
      let link = document.createElement('a');

      // Append the link to the document body (required for Firefox)
      document.body.appendChild(link);

      // Set the download attributes for the link
      link.setAttribute('href', this.base64Image);
      link.setAttribute('download', 'mrHankey.jpg');

      // Trigger the download by simulating a click on the link
      link.click();
    });
  }

  /**
   * Downloads an image from a specified URL and converts it to a base64 encoded string.
   * @param url The URL of the image to be downloaded.
   * @returns An Observable that emits a base64 encoded string of the image.
   */
  getBase64ImageFromURL(url: string): Observable<string> {
    return Observable.create((observer: Observer<string>) => {
      // Create an image element to hold the image
      const img: HTMLImageElement = new Image();
      // Set the cross origin attribute to allow the image to be downloaded from a different domain
      img.crossOrigin = 'Anonymous';
      // Set the image source to the specified URL
      img.src = url;
      // If the image is not already loaded, add event listeners to handle the load and error events
      if (!img.complete) {
        // When the image is loaded, get the base64 encoded string of the image
        // and emit it through the Observable
        img.onload = () => {
          observer.next(this.getBase64Image(img));
          observer.complete();
        };
        // If there is an error loading the image, emit the error through the Observable
        img.onerror = (err) => {
          observer.error(err);
        };
      } else {
        // If the image is already loaded, get the base64 encoded string of the image
        // and emit it through the Observable
        observer.next(this.getBase64Image(img));
        observer.complete();
      }
    });
  }

  /**
   * Returns a base64 encoded string of the image.
   * @param img The HTMLImageElement of the image to be converted.
   * @returns A base64 encoded string of the image.
   */
  getBase64Image(img: HTMLImageElement): string {
    const canvas: HTMLCanvasElement = document.createElement('canvas');
    canvas.width = img.width;
    canvas.height = img.height;
    const ctx: CanvasRenderingContext2D = canvas.getContext('2d');
    // Draw the image on the canvas
    ctx.drawImage(img, 0, 0);
    // Get the base64 encoded string of the image
    const dataURL: string = canvas.toDataURL('image/png');
    // Remove the data url prefix
    return dataURL.replace(/^data:image\/(png|jpg);base64,/, '');
  }
}
